import { getApiErrorMessage } from "shared/utils";
import type { ApiError } from "shared/utils";
import {
  PROFILE_DEFAULT_MESSAGE,
  PROFILE_FALLBACK_MESSAGES,
} from "entities/user";

const FALLBACK_MESSAGES: Record<number, string> = {
  ...PROFILE_FALLBACK_MESSAGES,
  400: "Invalid name. Please check the entered values.",
};

export const getUpdateUserNamesError = (error: ApiError): string | null =>
  getApiErrorMessage(error, FALLBACK_MESSAGES, PROFILE_DEFAULT_MESSAGE);
